import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingLeads", "existingLeadsText"]

  connect() {
    this.updateButtonText()
    this.setupRowClickHandlers()
    this.setupRadioChangeListeners()
  }

  setupRowClickHandlers() {
    const dropdownItems = this.element.querySelectorAll(".dropdown-item")

    dropdownItems.forEach((item) => {
      item.style.cursor = "pointer"

      item.addEventListener("click", (event) => {
        if (!event.target.matches('input[type="radio"]')) {
          event.preventDefault()
          const radioInput = item.querySelector('input[type="radio"]')
          if (radioInput && !radioInput.disabled) {
            radioInput.checked = true
            radioInput.dispatchEvent(new Event("change", { bubbles: true }))
          }
        }
      })
    })
  }

  setupRadioChangeListeners() {
    const radioInputs = this.element.querySelectorAll(
      'input[type="radio"][name="leads_import[existing_leads_handling]"]',
    )

    radioInputs.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleSelection()
      })
    })
  }

  handleSelection() {
    this.updateButtonText()
    setTimeout(() => {
      this.closeDropdown()
    }, 10)
  }

  closeDropdown() {
    const dropdownButton = this.element.querySelector(".h-select")

    if (dropdownButton && window.bootstrap && window.bootstrap.Dropdown) {
      const dropdown = window.bootstrap.Dropdown.getInstance(dropdownButton)
      if (dropdown) {
        dropdown.hide()
      }
    }
  }

  updateButtonText() {
    const selectedRadio = this.element.querySelector('input[type="radio"]:checked')
    const dropdownButton = this.element.querySelector(".h-select")

    if (selectedRadio && dropdownButton) {
      const dropdownItem = selectedRadio.closest(".dropdown-item")

      if (dropdownItem) {
        const titleElement = dropdownItem.querySelector(".custom-option__title")
        const subtitleElement = dropdownItem.querySelector(".custom-option__subtitle")

        if (titleElement && subtitleElement) {
          const optionTitle = titleElement.textContent.trim()
          const optionSubtitle = subtitleElement.textContent.trim()

          dropdownButton.textContent = optionTitle

          if (this.hasExistingLeadsTextTarget) {
            this.existingLeadsTextTarget.textContent = optionSubtitle
          }
        }
      }
    }
  }
}
